import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';

@Component({
  selector: 'app-vehicle-icon-uploader',
  templateUrl: './vehicle-icon-uploader.component.html',
  styleUrls: ['./vehicle-icon-uploader.component.scss']
})
export class VehicleIconUploaderComponent implements OnInit {

  @ViewChild('iconBtn') iconBtn: ElementRef;

  @Input()
  value: string;

  @Output()
  valueChange = new EventEmitter<string>();

  iconUrl: SafeResourceUrl;

  constructor(private domSanitizer: DomSanitizer) {
  }

  ngOnInit(): void {
    if (!this.value) {
      this.iconUrl = this.domSanitizer.bypassSecurityTrustResourceUrl('data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' xmlns:xlink=\'http://www.w3.org/1999/xlink\' aria-hidden=\'true\' focusable=\'false\' width=\'1em\' height=\'1em\' style=\'-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);\' preserveAspectRatio=\'xMidYMid meet\' viewBox=\'0 0 32 32\'%3E%3Cpath d=\'M30 3.414L28.586 2L2 28.586L3.414 30l2-2H26a2.003 2.003 0 0 0 2-2V5.414zM26 26H7.414l7.793-7.793l2.379 2.379a2 2 0 0 0 2.828 0L22 19l4 3.997zm0-5.832l-2.586-2.586a2 2 0 0 0-2.828 0L19 19.168l-2.377-2.377L26 7.414z\' fill=\'%23626262\'/%3E%3Cpath d=\'M6 22v-3l5-4.997l1.373 1.374l1.416-1.416l-1.375-1.375a2 2 0 0 0-2.828 0L6 16.172V6h16V4H6a2.002 2.002 0 0 0-2 2v16z\' fill=\'%23626262\'/%3E%3C/svg%3E');
    } else {
      this.iconUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(this.value);
    }
  }

  changeIconImg(e: any) {
    (this.iconBtn.nativeElement as HTMLElement).click();
  }

  onIconUpload(e: any) {
    const file = e.target.files[0];
    const reader = new FileReader();
    // this.loadingChange.emit(true);
    reader.onload = (event) => {
      // this.valueChange.emit(dataUrl);
      // this.profilePhoto.nativeElement.src = dataUrl;

      // this.loadingChange.emit(false);
      this.iconUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(reader.result as string);
      this.valueChange.emit(reader.result as string);
    };
    reader.readAsDataURL(file);
  }

}
